import { render, staticRenderFns } from "./centerDetail.vue?vue&type=template&id=666313e0&"
import script from "./centerDetail.vue?vue&type=script&lang=js&"
export * from "./centerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports